var _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLaurelWreath(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_375_1171)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_375_1171",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 120,
    height: 120
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M120 0H0V120H120V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_375_1171)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_375_1171)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M100.664 34.4531C104.077 40.6462 105.703 47.5071 105.703 54.7266C105.703 70.1362 101.133 82.1484 83.4799 93.0469L77.8125 91.6406L71.3672 89.7656C87.5048 83.0962 97.7344 69.8133 97.7344 54.1406C97.7344 46.7979 95.625 42.1875 92.2266 34.6875L100.664 34.4531Z",
    fill: "#FD8F32"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M81.0938 67.2657C81.0938 67.2657 85.0781 67.0313 85.0781 70.8985C85.0781 74.7657 81.0938 74.5313 81.0938 74.5313H60.2344V67.2657H81.0938Z",
    fill: "#FD8F32"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_375_1171)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.273 39.2578C38.8999 38.5558 39.8402 42.176 39.8433 42.1875L40.898 47.5781L33.5152 47.6953L32.812 44.5312C32.8088 44.5186 31.6453 39.96 35.273 39.2578Z",
    fill: "#FD8F32"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_375_1171)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M80.625 42.1874C80.625 42.1874 81.5625 38.5549 85.1953 39.2578C88.8281 39.9609 87.6562 44.5312 87.6562 44.5312L86.9531 47.6953L79.5703 47.5781L80.625 42.1874Z",
    fill: "#FD8F32"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_d_375_1171)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M60.3512 33.5156C64.4527 33.6328 63.984 37.5 63.984 37.5V43.8281H56.7184V37.5C56.7184 37.5 56.2496 33.3985 60.3512 33.5156Z",
    fill: "#FD8F32"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_d_375_1171)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M65.3456 91.3268C66.2592 89.9745 71.4841 89.5313 74.0149 89.7202C76.5454 89.9091 80.4175 91.0139 81.9276 91.9132C83.4374 92.8127 85.3856 94.369 86.9531 97.9688C88.525 101.579 89.7414 106.577 88.8281 107.93C87.9145 109.282 82.4992 109.755 79.7214 109.805C76.9525 109.855 71.8417 107.626 71.8087 107.612C71.7979 107.604 68.5211 105.164 66.9517 101.56C65.3798 97.9495 64.432 92.6794 65.3456 91.3268Z",
    fill: "#FBAC5B"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_d_375_1171)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.125 34.9219C24.7266 42.4219 22.6172 47.0323 22.6172 54.375C22.6172 70.0477 32.8467 83.3306 48.9844 90L42.5391 91.875L36.8714 93.2812C19.2187 82.3828 14.6484 70.3706 14.6484 54.9609C14.6484 47.7413 16.274 40.8806 19.6875 34.6875L28.125 34.9219Z",
    fill: "#FBAC5B"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter6_d_375_1171)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M98.604 71.1715C100.078 70.8762 102.627 70.368 106.351 71.6119C110.086 72.8594 114.637 75.6813 115.031 77.2652C115.425 78.8491 112.245 82.6851 110.424 84.783C108.607 86.8753 103.527 89.1837 103.5 89.1958C103.479 89.2001 99.477 89.9997 95.7521 88.7555C92.0176 87.5081 87.4665 84.6862 87.0725 83.1021C86.6787 81.5182 89.8583 77.6822 91.6796 75.5843C93.5009 73.4864 97.1295 71.4668 98.604 71.1715Z",
    fill: "#FBAC5B"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M60.2344 37.5C60.236 37.5 62.6958 37.3838 63.9844 40.0781C65.2725 42.7716 69.6033 52.2523 69.6094 52.2656L80.3906 44.5313C80.3948 44.5275 81.9173 43.1252 84.375 43.3594C86.8327 43.5935 87.1866 46.6324 87.1875 46.6406C87.1875 46.6406 86.1823 53.0803 85.4297 57.1875C84.6734 61.3153 83.3229 67.7222 83.3203 67.7344C83.3173 67.733 82.2431 67.2656 80.3906 67.2656H60.2344V74.5312H39.375C39.375 74.5312 35.3906 74.7656 35.3906 70.8984C35.3906 67.0317 39.3741 67.2656 39.375 67.2656H60.2344V37.5Z",
    fill: "#FBAC5B"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter7_d_375_1171)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M109.387 42.7243C113.258 42.0048 118.607 42.2666 119.719 43.4609C120.832 44.6553 119.91 49.5516 119.334 52.2697C118.76 54.9814 115.433 59.4657 115.418 59.4863C115.4 59.5013 112.288 62.1394 108.428 62.8569C104.557 63.5764 99.2087 63.3148 98.0961 62.1205C96.9838 60.9258 97.9049 56.0295 98.481 53.3117C99.0568 50.5937 101.553 47.0731 102.398 46.0951C103.242 45.117 105.527 43.4417 109.387 42.7243Z",
    fill: "#FBAC5B"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter8_d_375_1171)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M95.6252 14.7656C98.7892 12.422 103.711 10.3128 105.235 10.8984C106.758 11.4845 108.076 16.2891 108.75 18.9844C109.422 21.6738 108.398 27.1634 108.394 27.1875C108.383 27.2107 106.743 30.9448 103.589 33.2813C100.425 35.625 95.503 37.7344 93.9796 37.1484C92.4562 36.5623 91.1376 31.7578 90.464 29.0625C89.7916 26.3733 90.816 20.8846 90.8207 20.8594C90.8301 20.8379 92.4702 17.1027 95.6252 14.7656Z",
    fill: "#FBAC5B"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter9_d_375_1171)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.5255 89.7197C49.0561 89.5308 54.281 89.9738 55.1951 91.3261C56.1087 92.6787 55.1606 97.9491 53.5887 101.559C52.0193 105.163 50.625 106.461 48.732 107.612C46.8389 108.762 43.5909 109.854 40.8192 109.804C38.0414 109.754 32.6259 109.282 31.7126 107.929C30.7992 106.576 32.0156 101.578 33.5876 97.9681C35.1548 94.3683 37.1032 92.812 38.613 91.9125C40.1229 91.0132 43.9948 89.9086 46.5255 89.7197Z",
    fill: "#FDDB8D"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter10_d_375_1171)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.1914 71.6116C17.9152 70.3678 20.4644 70.8759 21.9388 71.1712C23.4131 71.4665 27.0418 73.4861 28.8631 75.584C30.6844 77.6819 33.864 81.5177 33.4702 83.1018C33.0765 84.686 28.5254 87.5079 24.7906 88.7552C21.0622 90.0007 18.6325 89.3768 17.0432 89.1958C15.454 89.0149 11.9365 86.876 10.1191 84.7828C8.29771 82.6849 5.1181 78.8489 5.51195 77.265C5.90621 75.6811 10.4569 72.859 14.1914 71.6116Z",
    fill: "#FDDB8D"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter11_d_375_1171)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M60.2344 67.2656H40.0781C38.2228 67.2656 37.1484 67.7344 37.1484 67.7344C37.1482 67.733 35.7961 61.3186 35.0391 57.1875C34.287 53.0834 33.2827 46.6505 33.2812 46.6406C33.2812 46.6406 33.6328 43.5938 36.0938 43.3594C38.5477 43.1257 40.0695 44.5233 40.0781 44.5313L50.8594 52.2656C50.8594 52.2656 55.1953 42.7734 56.4844 40.0781C57.769 37.392 60.2177 37.4993 60.2344 37.5V67.2656Z",
    fill: "#FDDB8D"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter12_d_375_1171)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.823634 43.4611C1.93624 42.2667 7.28467 42.0047 11.1558 42.7242C15.0158 43.4416 17.3006 45.1172 18.1452 46.0952C18.9897 47.0733 21.4861 50.5936 22.062 53.3116C22.6379 56.0295 23.5591 60.9258 22.4468 62.1204C21.3343 63.3148 15.9861 63.5766 12.1148 62.857C8.24992 62.1387 5.74217 59.9998 5.12502 59.4862C4.50767 58.972 1.78305 54.9816 1.20838 52.2698C0.632468 49.5518 -0.288663 44.6555 0.823634 43.4611Z",
    fill: "#FDDB8D"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter13_d_375_1171)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.3065 10.8977C16.8302 10.312 21.752 12.4213 24.9158 14.7649C28.0707 17.1018 28.9735 19.2178 29.7205 20.8586C30.4672 22.4995 30.751 26.3664 30.0772 29.0617C29.4033 31.7571 28.085 36.5615 26.5615 37.1477C25.0381 37.7336 20.1162 35.6242 16.9522 33.2805C13.7934 30.9407 12.6548 28.2417 12.1475 27.1867C11.6402 26.1316 11.1186 21.6729 11.7909 18.9836C12.4647 16.2883 13.7831 11.4836 15.3065 10.8977Z",
    fill: "#FDDB8D"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_375_1171",
    x: 70.3672,
    y: 33.4531,
    width: 36.3359,
    height: 60.5938,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_375_1171"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_375_1171",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_375_1171",
    x: 31.6318,
    y: 38.1675,
    width: 10.2666,
    height: 10.5278,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_375_1171"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_375_1171",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_375_1171",
    x: 78.5703,
    y: 38.1675,
    width: 10.2666,
    height: 10.5278,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_375_1171"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_375_1171",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_d_375_1171",
    x: 55.7021,
    y: 32.5132,
    width: 9.29785,
    height: 12.3149,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_375_1171"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_375_1171",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_d_375_1171",
    x: 63.9883,
    y: 88.6787,
    width: 26.1543,
    height: 22.127,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_375_1171"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_375_1171",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_d_375_1171",
    x: 13.6484,
    y: 33.6875,
    width: 36.3359,
    height: 60.5938,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_375_1171"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_375_1171",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_d_375_1171",
    x: 86.0391,
    y: 69.8142,
    width: 30.0254,
    height: 20.6384,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_375_1171"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_375_1171",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter7_d_375_1171",
    x: 96.5732,
    y: 41.3262,
    width: 24.6689,
    height: 22.929,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_375_1171"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_375_1171",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter8_d_375_1171",
    x: 89.2354,
    y: 9.79956,
    width: 20.7432,
    height: 28.4478,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_375_1171"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_375_1171",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter9_d_375_1171",
    x: 30.3984,
    y: 88.6782,
    width: 26.1543,
    height: 22.1277,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_375_1171"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_375_1171",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter10_d_375_1171",
    x: 4.47852,
    y: 69.814,
    width: 30.0254,
    height: 20.6985,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_375_1171"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_375_1171",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter11_d_375_1171",
    x: 32.2812,
    y: 36.4993,
    width: 28.9531,
    height: 32.2351,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_375_1171"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_375_1171",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter12_d_375_1171",
    x: -0.699219,
    y: 41.3262,
    width: 24.6689,
    height: 22.929,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_375_1171"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_375_1171",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter13_d_375_1171",
    x: 10.4717,
    y: 9.79883,
    width: 20.9863,
    height: 28.4478,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_375_1171"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_375_1171",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_375_1171"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 120,
    height: 120,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLaurelWreath);
export default __webpack_public_path__ + "static/media/laurel_wreath.71428885497ff1ae5f54cc246ab59af2.svg";
export { ForwardRef as ReactComponent };